import React from 'react';
const NoAgentSVG = ({ className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='136'
      height='121'
      viewBox='0 0 136 121'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <circle cx='67.6694' cy='64.755' r='55.8452' fill='#E6F3FD' />
      <path
        d='M14.8516 68.6712C14.8516 54.5163 20.4746 40.9412 30.4836 30.9321C40.4926 20.9231 54.0678 15.3001 68.2227 15.3001C82.3776 15.3001 95.9528 20.9231 105.962 30.9321C115.971 40.9412 121.594 54.5163 121.594 68.6712'
        stroke='#8CC2F6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M115.72 89.9872H105.187V47.9026H115.72C118.301 47.9026 120.777 48.9281 122.602 50.7535C124.428 52.5789 125.453 55.0546 125.453 57.6361V80.2537C125.453 82.8352 124.428 85.3109 122.602 87.1363C120.777 88.9617 118.301 89.9872 115.72 89.9872Z'
        fill='#B9DBFA'
      />
      <path
        d='M20.3545 47.9027H30.8867V89.9872H20.3545C17.7731 89.9872 15.2973 88.9617 13.472 87.1364C11.6466 85.311 10.6211 82.8353 10.6211 80.2538V57.6361C10.6211 55.0547 11.6466 52.5789 13.472 50.7536C15.2973 48.9282 17.7731 47.9027 20.3545 47.9027Z'
        fill='#B9DBFA'
      />
      <path
        d='M68.2226 113.3C92.8704 113.3 112.851 93.3193 112.851 68.6715C112.851 44.0237 92.8704 24.0427 68.2226 24.0427C43.5747 24.0427 23.5938 44.0237 23.5938 68.6715C23.5938 93.3193 43.5747 113.3 68.2226 113.3Z'
        fill='#E6F3FD'
        stroke='#8CC2F6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M54.2734 86.4813C54.9655 83.2962 56.7267 80.4438 59.2643 78.3983C61.802 76.3528 64.9633 75.2373 68.2227 75.2373C71.4822 75.2373 74.6434 76.3528 77.1811 78.3983C79.7188 80.4438 81.48 83.2962 82.172 86.4813'
        stroke='#8CC2F6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M83.9783 69.8398C85.073 69.8398 85.9605 68.9523 85.9605 67.8576C85.9605 66.7628 85.073 65.8754 83.9783 65.8754C82.8835 65.8754 81.9961 66.7628 81.9961 67.8576C81.9961 68.9523 82.8835 69.8398 83.9783 69.8398Z'
        fill='#8CC2F6'
      />
      <path
        d='M52.4705 69.8398C53.5652 69.8398 54.4527 68.9523 54.4527 67.8576C54.4527 66.7628 53.5652 65.8754 52.4705 65.8754C51.3757 65.8754 50.4883 66.7628 50.4883 67.8576C50.4883 68.9523 51.3757 69.8398 52.4705 69.8398Z'
        fill='#8CC2F6'
      />
      <circle cx='15.3245' cy='27.0474' r='3.50027' fill='#E6F3FD' />
      <circle cx='105.855' cy='13.2052' r='6.52323' fill='#E6F3FD' />
      <circle cx='6.4394' cy='100.712' r='6.20502' fill='#E6F3FD' />
      <circle cx='127.494' cy='94.6658' r='6.20502' fill='#E6F3FD' />
      <ellipse
        cx='115.402'
        cy='101.667'
        rx='3.02296'
        ry='3.02296'
        fill='#E6F3FD'
      />
      <path
        d='M22.444 110.593C22.128 110.526 22.128 110.075 22.444 110.007L25.8279 109.28C25.9433 109.255 26.0334 109.165 26.0582 109.05L26.7848 105.666C26.8527 105.35 27.3036 105.35 27.3714 105.666L28.0981 109.05C28.1228 109.165 28.213 109.255 28.3284 109.28L31.7122 110.007C32.0282 110.075 32.0282 110.526 31.7122 110.593L28.3284 111.32C28.213 111.345 28.1228 111.435 28.0981 111.55L27.3714 114.934C27.3036 115.25 26.8527 115.25 26.7848 114.934L26.0582 111.55C26.0334 111.435 25.9433 111.345 25.8279 111.32L22.444 110.593Z'
        fill='#B9DBFA'
      />
      <path
        d='M32.8493 1.40314C32.9172 1.08222 33.3753 1.08221 33.4433 1.40314L33.8932 3.52867C33.9179 3.64551 34.0089 3.73699 34.1255 3.76241L36.2397 4.22297C36.5583 4.29238 36.5583 4.74677 36.2397 4.81617L34.1255 5.27674C34.0089 5.30216 33.9179 5.39364 33.8932 5.51048L33.4433 7.636C33.3753 7.95693 32.9172 7.95693 32.8493 7.636L32.3994 5.51048C32.3747 5.39364 32.2837 5.30216 32.167 5.27674L30.0529 4.81617C29.7343 4.74677 29.7343 4.29238 30.0529 4.22297L32.167 3.76241C32.2837 3.73699 32.3747 3.64551 32.3994 3.52867L32.8493 1.40314Z'
        fill='#B9DBFA'
      />
      <path
        d='M117.357 29.5727C117.479 28.995 118.303 28.995 118.426 29.5727L118.792 31.3052C118.837 31.5155 119.001 31.6802 119.211 31.7259L120.953 32.1054C121.526 32.2303 121.526 33.0483 120.953 33.1732L119.211 33.5527C119.001 33.5985 118.837 33.7631 118.792 33.9735L118.426 35.7059C118.303 36.2836 117.479 36.2836 117.357 35.7059L116.99 33.9735C116.945 33.7631 116.782 33.5985 116.572 33.5527L114.83 33.1732C114.256 33.0483 114.256 32.2303 114.83 32.1054L116.572 31.7259C116.782 31.6802 116.945 31.5155 116.99 31.3052L117.357 29.5727Z'
        fill='#B9DBFA'
      />
      <path
        d='M130.407 75.52L131.381 80.1236L135.919 81.1121L131.381 82.1007L130.407 86.7043L129.432 82.1007L124.895 81.1121L129.432 80.1236L130.407 75.52Z'
        fill='white'
      />
    </svg>
  );
};

export default NoAgentSVG;
